import React from 'react'
import '../style/footer.css'
import logo from '../images/mttlogo.png'
import { Link } from 'react-router-dom'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import AccessTimeIcon from '@mui/icons-material/AccessTime'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="logo-text">
        <Link to="/">
          <img src={logo} alt="MTT Ubezpieczenia Logo" className="logo-img" />
        </Link>
      </div>

      <div className="footer-section company">
        <h3>MTT Ubezpieczenia</h3>
        <h4>Małgorzata Tyc-Tomiczek</h4>
        <p>NIP: 5532219670</p>
        <p>REGON: 522573772</p>
        <p>ul. Plażowa 3, 34-360 Milówka</p>
      </div>

      <div className="footer-section contact">
        <h3>Kontakt</h3>
        <p>
          <PhoneIcon style={{ verticalAlign: 'middle', marginRight: '8px', color: '#4ECDC4' }} />
          <a href="tel:+48666691526">+48 666 691 526</a>
        </p>
        <p>
          <EmailIcon style={{ verticalAlign: 'middle', marginRight: '8px', color: '#FF6B6B'  }} />
          <a href="mailto:mtt.ubezpieczenia@gmail.com">mtt.ubezpieczenia@gmail.com</a>
        </p>
        <p>
          <AccessTimeIcon style={{ verticalAlign: 'middle', marginRight: '8px', color: '#FFD93D' }} />
          Godziny otwarcia:
        </p>
        <p>
          <AccessTimeIcon style={{ verticalAlign: 'middle', marginRight: '8px', opacity: 0.6, fontSize: '18px', color: '#FFD93D' }} />
          Pon-Pt 16:00 - 18:00
        </p>
      </div>

      <div className="footer-section links">
        <h3>Linki</h3>
        <ul>
          <li><Link to="/">Strona główna</Link></li>
          <li><Link to="/kontakt">Kontakt</Link></li>
          <li><Link to="/o-nas">O nas</Link></li>
          <li><Link to="/ubezpieczenia/zglos-szkode">Zgłoś szkodę</Link></li>
          <li>
            <Link to="/polityka-prywatnosci" className="policy-button">
              Polityka prywatności
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  )
}

export default Footer
